export class LoginFields {
    email: string;
    password: string;
}
